// extracted by mini-css-extract-plugin
var _1 = "assets-js-common-components-MegaNav-MegaNavVariant-components-GlobalNav-components-Logo-Logo-module__image__Qdxli";
export { _1 as "image" }
